import ApiService from "@/core/services/api.service";
import {commonExport} from "@/core/common/commonHelper";
import {GET_BRANCH_CONTRACT} from "@/core/services/store/contract/contracts.module";
export const GET_CUSTOMER_CRM = "get-crm-customer";
export const GET_CUSTOMER_USER = "get-crm-user";
export const EXPORT_CUSTOMER_CRM = "crm-customer-export";
export const CUSTOMER_FINANCE = "customers/detail/finance";
export const CUSTOMER_STUDY = "customers/detail/study";
export const CUSTOMER_TICKET = "customers/detail/ticket";
export const CUSTOMER_TICKET_DETAIL = "customers/show/ticket";
export const CRM_KINH_DOANH = "crm-kinh-doanh";
export const CHANGE_NGUOI_GIOI_THIEU = "thay-doi-nguoi-gt";
export const UPDATE_CUSTOMER = "update";
export const HISTORY_CRM = "history-crm";
export const CUSTOMER_SCHEDULE_LIST = "customers/show/schedule";
export const STUDY_RESULT = "customers/study-result";
export const DETAIL_TEST_STUDENT = "customers/detail-test-student";
export const DETAIL_EXAM_RETAKES = "customers/detail-student-exam-retakes"
export const GET_TEACHER_COMMEMNT = "customers/get-teacher-comment";
export const GET_REFUND_BY_USER = "customers/refunds";
export const EXPORT_DSKH_TU_VAN = "customers/export-dskh-tu-van";
export const UPDATE_INFO_USER = "update-info-user";
export const GET_INFO_USER_PARENT = "get-info-user-parent";
export const GET_TEST_INPUT_USER = "customers/test-input";
export const ADD_USER_PARENT = "add-info-user-parent";
export const UPDATE_INFO_BORROWER = "citime-update-payer";
export const SAVE_RESULT_CALL_TVV = "citime-consultation-result";
export const GET_INFO_BORROWER = "citime/contracts";
export const GET_RESULT_HANDLE = "citime/get-consultation-results";
export const GET_INFO_QR_CITIME = "citime-payment-info";
export const SAVE_RESULT_CONTRACT = "citime-save-draft";
export const REQUEST_ADDITIONAL_CITIME = "citime-request-supplement";
export const ACCEPT_FILE_CITIME = "citime-approve";
export const SIGN_CONTRACT_CITIME = "citime-sign";
export const CANCEL_CONTRACT_CITIME = "citime-cancel-contract";
export const CHANGE_WARRANTY_CONDITION = "customers/change-warranty-condition";
export const STAGE_REVIEW_DETAIL = "customers/stage-review-detail"

const mutations = {};
const state = {};
const getters = {};
const actions = {
  [HISTORY_CRM](context, payload) {
    return new Promise(resolve => {
      ApiService.query(`customers/${HISTORY_CRM}/${payload.id}`, payload).then(({data}) => {
        resolve(data);
      }).catch((response) => {
        console.log(response);
      });
    })
  },
  [UPDATE_CUSTOMER](context, payload) {
    return new Promise(resolve => {
      ApiService.post(`customers/${UPDATE_CUSTOMER}/${payload.customer_id}`, payload).then(({data}) => {
        resolve(data);
      }).catch((response) => {
        console.log(response);
      });
    })
  },

  [UPDATE_INFO_USER](context, payload) {
    console.log(payload,'data')
    return new Promise(resolve => {
      ApiService.post(`customers/${UPDATE_INFO_USER}`, payload).then(({data}) => {
        resolve(data);
      }).catch((response) => {
        console.log(response);
      });
    })
  },
  [STAGE_REVIEW_DETAIL](context, payload) {
    return new Promise(resolve => {
      ApiService.query(STAGE_REVIEW_DETAIL, payload).then(({data}) => {
        resolve(data);
      }).catch((response) => {
        console.log(response);
      });
    })
  },
  [CHANGE_NGUOI_GIOI_THIEU](context, payload) {
    return new Promise(resolve => {
      ApiService.query(`customers/${CHANGE_NGUOI_GIOI_THIEU}`, payload).then(({data}) => {
        resolve(data);
      }).catch((response) => {
        console.log(response);
      });
    })
  },
  [CRM_KINH_DOANH](context, payload) {
    return new Promise(resolve => {
      ApiService.query(`customers/${CRM_KINH_DOANH}/${payload.id}`, payload).then(({data}) => {
        resolve(data);
      }).catch((response) => {
        console.log(response);
      });
    })
  },
  [GET_CUSTOMER_CRM](context, payload) {
    return new Promise(resolve => {
      ApiService.query(`customers/${GET_CUSTOMER_CRM}`, payload).then(({data}) => {
        resolve(data);
      }).catch((response) => {
        console.log(response);
      });
    })
  },
  [GET_CUSTOMER_USER](context, payload) {
    return new Promise(resolve => {
      ApiService.query(`customers/user/${payload.id}`, {}).then(({data}) => {
        resolve(data);
      }).catch((response) => {
        console.log(response);
      });
    })
  },
  [GET_INFO_USER_PARENT](context, payload) {
    return new Promise(resolve => {
      ApiService.query(`customers/user-parent/${payload.id}`, {}).then(({data}) => {
        resolve(data);
      }).catch((response) => {
        console.log(response);
      });
    })
  },
  [ADD_USER_PARENT](context, payload) {
    return new Promise(resolve => {
      ApiService.post(`customers/add-user-parent`, payload).then(({data}) => {
        resolve(data);
      }).catch((response) => {
        console.log(response);
      });
    })
  },
  [GET_TEST_INPUT_USER](context, payload) {
    return new Promise(resolve => {
      ApiService.query(`${GET_TEST_INPUT_USER}/${payload.id}`, {}).then(({data}) => {
        resolve(data);
      }).catch((response) => {
        console.log(response);
      });
    })
  },
  [EXPORT_CUSTOMER_CRM](context, payload) {
    return new Promise(resolve => {
      ApiService.query(`customers/${EXPORT_CUSTOMER_CRM}`, payload).then(({data}) => {
        resolve(data);
      }).catch((response) => {
        console.log(response);
      });
    })
  },
  [EXPORT_DSKH_TU_VAN](context, payload) {
    return new Promise(resolve => {
      ApiService.query(`${EXPORT_DSKH_TU_VAN}`, payload).then(({data}) => {
        resolve(data);
      }).catch((response) => {
        console.log(response);
      });
    })
  },
  /**
   * api tài chính
   * @param context
   * @param id
   * @returns {Promise<unknown>}
   */
  [CUSTOMER_FINANCE](context, id) {
    return new Promise((resolve, reject) => {
      ApiService.query(`${CUSTOMER_FINANCE}/${id}`).then(({data}) => {
        resolve(data);
      }).catch(({response}) => {
        reject(response);
      });
    })
  },

  /**
   * api tài chính
   * @param context
   * @param id
   * @returns {Promise<unknown>}
   */
  [CUSTOMER_STUDY](context, id) {
    return new Promise((resolve, reject) => {
      ApiService.query(`${CUSTOMER_STUDY}/${id}`).then(({data}) => {
        resolve(data);
      }).catch(({response}) => {
        reject(response);
      });
    })
  },

  /**
   * api tài chăm sóc khách hàng
   * @param context
   * @param id
   * @returns {Promise<unknown>}
   */
  [CUSTOMER_TICKET](context, id) {
    return new Promise((resolve, reject) => {
      ApiService.query(`${CUSTOMER_TICKET}/${id}`).then(({data}) => {
        resolve(data);
      }).catch(({response}) => {
        reject(response);
      });
    })
  },

  /**
   * api chi tiết ticket
   * @param context
   * @param id
   * @returns {Promise<unknown>}
   */
  [CUSTOMER_TICKET_DETAIL](context, id) {
    return new Promise((resolve, reject) => {
      ApiService.query(`${CUSTOMER_TICKET_DETAIL}/${id}`).then(({data}) => {
        resolve(data);
      }).catch(({response}) => {
        reject(response);
      });
    })
  },

  /**
   * api chi tiết lớp học
   * @param context
   * @param id
   * @returns {Promise<unknown>}
   */
  [CUSTOMER_SCHEDULE_LIST](context, id) {
    return new Promise((resolve, reject) => {
      ApiService.query(`${CUSTOMER_SCHEDULE_LIST}/${id}`).then(({data}) => {
        resolve(data);
      }).catch(({response}) => {
        reject(response);
      });
    })
  },

  [STUDY_RESULT](context, id) {
    return new Promise((resolve, reject) => {
      ApiService.query(`${STUDY_RESULT}/${id}`).then(({data}) => {
        resolve(data);
      }).catch(({response}) => {
        reject(response);
      });
    })
  },

  [DETAIL_TEST_STUDENT](context, payload) {
    return new Promise((resolve, reject) => {
      ApiService.query(`${DETAIL_TEST_STUDENT}`, payload).then(({data}) => {
        resolve(data);
      }).catch(({response}) => {
        reject(response);
      });
    })
  },
  [DETAIL_EXAM_RETAKES](context, payload) {
    return new Promise((resolve, reject) => {
      ApiService.query(`${DETAIL_EXAM_RETAKES}`, payload).then(({data}) => {
        resolve(data)
      }).catch(({response}) => {
        reject(response);
      });
    })
  },
  [GET_TEACHER_COMMEMNT](context, payload) {
    return new Promise((resolve, reject) => {
      ApiService.query(`${GET_TEACHER_COMMEMNT}`, payload).then(({data}) => {
        resolve(data);
      }).catch(({response}) => {
        reject(response);
      });
    })
  },

  /**
   * api get qua tang theo user
   * @param context
   * @param id
   * @returns {Promise<unknown>}
   */

  [GET_REFUND_BY_USER](context, payload) {
    return new Promise((resolve, reject) => {
      ApiService.query(`${GET_REFUND_BY_USER}`, payload).then(({data}) => {
        resolve(data);
      }).catch(({response}) => {
        reject(response)
      });
    })
  },

  [UPDATE_INFO_BORROWER](context, payload) {
      return new Promise((resolve, reject) => {
        ApiService.patch(`citime/contracts/${payload.id}/payer`, payload).then(({data}) => {
            resolve(data);
        }).catch((error) => {
            reject(error.response || error);
        });
    })
  },

  [GET_INFO_BORROWER](context, payload) {
    return new Promise(resolve => {
        ApiService.query(`citime/contracts/${payload.id}`).then(({data}) => {
            resolve(data);
        }).catch((response) => {
            console.log(response);
        });
    })
  },

  [GET_RESULT_HANDLE](context, payload) {
    return new Promise(resolve => {
        ApiService.query(GET_RESULT_HANDLE, payload).then(({data}) => {
            resolve(data);
        }).catch((response) => {
            console.log(response);
        });
    })
  },

  [SAVE_RESULT_CALL_TVV](context, payload) {
      return new Promise((resolve, reject) => {
        ApiService.post(`citime/contracts/${payload.id}/consultation-result` , payload).then(({data}) => {
            resolve(data);
        }).catch((error) => {
            reject(error.response || error);
        });
    })
  },

  [GET_INFO_QR_CITIME](context, payload) {
      return new Promise((resolve, reject) => {
        ApiService.query(`citime/contracts/${payload.id}/payment-info`).then(({data}) => {
            resolve(data);
        }).catch((error) => {
            reject(error.response || error);
        });
    })
  },

  [SAVE_RESULT_CONTRACT](context, payload) {
      return new Promise((resolve, reject) => {
        ApiService.post(`citime/contracts/${payload.id}/save-draft`, payload).then(({data}) => {
            resolve(data);
        }).catch((error) => {
            reject(error.response || error);
        });
    })
  },

  [REQUEST_ADDITIONAL_CITIME](context, payload) {
      return new Promise((resolve, reject) => {
        ApiService.post(`citime/contracts/${payload.id}/request-supplement`, payload).then(({data}) => {
            resolve(data);
        }).catch((error) => {
            reject(error.response || error);
        });
    })
  },

  [ACCEPT_FILE_CITIME](context, payload) {
      return new Promise((resolve, reject) => {
        ApiService.post(`citime/contracts/${payload.id}/approve`).then(({data}) => {
            resolve(data);
        }).catch((error) => {
            reject(error.response || error);
        });
    })
  },

  [SIGN_CONTRACT_CITIME](context, payload) {
    return new Promise((resolve, reject) => {
        ApiService.post(`citime/contracts/${payload.id}/sign`, payload)
            .then(({ data }) => {
                resolve(data);
            })
            .catch((error) => {
                reject(error.response || error);
            });
    });
  },
  [CANCEL_CONTRACT_CITIME](context, payload) {
    return new Promise(resolve => {
        ApiService.post(`citime/contracts/${payload.id}/cancel`, payload).then(({data}) => {
            resolve(data);
        }).catch((response) => {
            console.log(response);
        });
    })
  },

  [CHANGE_WARRANTY_CONDITION](context, payload) {
    return new Promise((resolve, reject) => {
        ApiService.post(`${CHANGE_WARRANTY_CONDITION}`, payload).then(({data}) => {
            resolve(data);
        }).catch(({response}) => {
            reject(response)
        });
    })
  },
}
export default {
  state,
  actions,
  mutations,
  getters
};
